module.exports = __webpack_public_path__ + "static/media/viewReports.3e212947.svg";